import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import Dashboard2Service from "@/views/dashboard2/services/dashboard2.service";
import {
  Dashboard2Snapshot,
  createEmptyDashboard2Snapshot
} from "@/views/dashboard2/types/dashboard2.types";

@Module({ namespaced: true })
class Dashboard2 extends VuexModule {
  snapshot: Dashboard2Snapshot = createEmptyDashboard2Snapshot();
  loading = false;

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchSnapshot({
    clientId,
    participantId,
    timezone,
    startDate,
    endDate
  }: {
    clientId: number;
    participantId: number;
    timezone?: string;
    startDate?: string;
    endDate?: string;
  }) {
    this.context.commit("updateField", {
      path: "loading",
      value: true
    });

    try {
      const snapshot = await Dashboard2Service.getDashboardSnapshot(
        clientId,
        participantId,
        timezone,
        startDate,
        endDate
      );
      this.context.commit("updateField", {
        path: "snapshot",
        value: snapshot
      });
    } finally {
      this.context.commit("updateField", {
        path: "loading",
        value: false
      });
    }
  }

  @Action({ rawError: true })
  initializeMockSnapshot() {
    const snapshot = Dashboard2Service.getDashboardSnapshotMock();
    this.context.commit("updateField", {
      path: "snapshot",
      value: snapshot
    });
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

Dashboard2.getters = { getField };
Dashboard2.mutations = { updateField };

export default Dashboard2;
